export default class {
    /**
     * Functionality for all live preview components in IDC
     * @param Configurator
     */
    constructor(Configurator) {
        this.Configurator   = Configurator;
        this.Design         = Configurator.Design;
        this.Progress       = Configurator.Progress;
    }

    // Default values
    get colors() {
        return App.Variable('colors')[this.Configurator.data.color.color || App.Variable('color')];
    }

    // Components
    get Tin() { return this.Design.Tin }

    get Label() {
        return (async () => {
            return App.Components.wait('.js-idc-label', App.Components.MAIN_INSTANCE_NAME, null, true);
        })();
    }

    setTinPosition(degree) {
        this.Tin.center(degree);
    }

    // Methods

    /**
     * Prepare configurator on actual values to start a new configuration
     *
     * Because we do not want the tin showing rests of a not relevant design
     * we re-set the tin to look with default values so far
     */
    async prepareTin() {
        this.Tin.setDesign(this.Design.dummy);
    }

    /**
     * This restores tin with the data coming from the storage
     * @return {Promise<void>}
     */
    async restoreTin() {
        this.setText(this.Configurator.Progress.get('text').values.name);
        this.setDescription(this.Configurator.Progress.get('text').values.description);
    }

    /**
     * Set text to all previews
     */
    async setText(name) {
        this.Tin.setName(name).update();
        (await this.Label).setName(name).update();
    }

    /**
     * Set description to all previews
     */
    async setDescription(description) {
        this.Tin.setDescription(description).update();
        (await this.Label).setDescription(description).update();
    }

    /**
     * Set colors to all preview
     * @param primary HEX color
     * @param secondary HEX color
     */
    async setColors(primary, secondary) {
        this.setPrimaryColor(primary);
        this.setSecondaryColor(secondary);
    }

    async setPrimaryColor(primary) {
        this.Tin
            .setPrimaryColor(primary)
            .update()
        ;
        (await this.Label)
            .setPrimaryColor(primary)
            .update()
        ;
    }

    async setSecondaryColor(secondary) {
        this.Tin
            .setSecondaryColor(secondary)
            .update()
        ;
        (await this.Label)
            .setSecondaryColor(secondary)
            .update()
        ;
    }

    /**
     * Set colors by identifier
     * @param identifier Color from repository
     */
    async setColor(identifier) {
        const colors = this.Configurator.color(identifier);
        await this.setColors(colors['primary'], colors['secondary']);
    }

    /**
     * Set Image to all preview
     * @param image
     * @return {Promise<void>}
     */
    async setImage(image) {
        this.Tin.setImage(image).update();
        (await this.Label).setImage(image).update();
    }

    async setOpacity(opacity) {
        this.Tin
            .setOpacity(opacity / 100)
            .update()
        ;
        (await this.Label).setOpacity(opacity / 100).update();
    }
}
